export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/57acb592-82f9-4baf-bfd4-c80f0a3a54d2/images/cafae60e4c2fbb3edbb89ea089183d824d8afedc3f2704a1bb3b12f5b64e3c37.png",
  portrait: "https://customer-assets-eiarnc6j.emergentagent.net/job_healing-space-109/artifacts/38e0grmv_9BBFF892-3330-466A-832B-EE62825874CC-91388-00001645960B41EB.webp",
  over: "https://static.prod-images.emergentagent.com/jobs/57acb592-82f9-4baf-bfd4-c80f0a3a54d2/images/e16bb7caac90c6264e4395e0ed335cc1b03da47a89fa4449cca51fc6b2743037.png",
  contact: "https://static.prod-images.emergentagent.com/jobs/57acb592-82f9-4baf-bfd4-c80f0a3a54d2/images/06292d4cf7a9d5e8717ae07687699129ee0c9e95815d36e3462b7998f2cb94bf.png",
  praktijk: "https://customer-assets-eiarnc6j.emergentagent.net/job_healing-space-109/artifacts/9hoktxlx_95484424-9a37-4a34-9ec2-e83f9a5e67f8.jpe",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Over mij", href: "#over" },
  { label: "Aanbod", href: "#aanbod" },
  { label: "Werkwijze en tarieven", href: "#werkwijze" },
  { label: "Contact", href: "#contact" },
];

export const FAQ_ITEMS = [
  {
    q: "Heb ik een doorverwijzing nodig?",
    a: [
      "Nee, een doorverwijzing is niet nodig. Je kan rechtstreeks contact opnemen wanneer je vragen hebt of graag ondersteuning wenst.",
      "Soms worden mensen doorverwezen door een huisarts, school, CLB of een andere hulpverlener. Dat kan zeker, maar het is geen voorwaarde. Je bent zeker welkom als je zelf de stap wil zetten.",
      "Twijfel je of jouw hulpvraag bij De Kern past? Neem gerust contact op. Samen kijken we wat jouw vraag is en of mijn begeleiding aansluit bij wat jij of je gezin nodig heeft.",
    ],
  },
  {
    q: "Word ik als ouder betrokken in de begeleiding van mijn kind?",
    a: [
      "Ja, absoluut.",
      "Ik geloof dat kinderen het meest groeien wanneer ook de mensen rondom hen begrijpen wat ze nodig hebben. Daarom zie ik ouders als een belangrijke partner in de begeleiding.",
      "Tijdens het traject nemen we regelmatig de tijd om stil te staan bij wat er speelt, welke inzichten er ontstaan en hoe je je kind ook thuis kan ondersteunen.",
      "Tegelijk is het belangrijk dat je kind zich veilig voelt om vrijuit te kunnen praten. Daarom is er tijdens de sessie ook ruimte voor vertrouwelijke gesprekken. Zo creëren we een veilige plek waarin je kind zichzelf mag zijn. Wanneer er belangrijke zaken naar voren komen die ouders best weten, bespreek ik samen met je kind hoe we dit kunnen delen.",
    ],
  },
  {
    q: "Heb jij beroepsgeheim?",
    a: [
      "Ja, als therapeut heb ik beroepsgeheim. Dat betekent dat wat tijdens de begeleiding verteld wordt, vertrouwelijk blijft. Die veiligheid is belangrijk zodat kinderen, jongeren én volwassenen open kunnen vertellen wat hen bezighoudt.",
      "Bij kinderen en jongeren zoek ik steeds naar een evenwicht tussen die vertrouwelijkheid en het betrekken van ouders. Ouders krijgen uiteraard de nodige inzichten en handvatten om hun kind te ondersteunen, maar persoonlijke zaken die een kind vertelt worden niet zomaar doorverteld.",
      "Wanneer ik denk dat het belangrijk is om bepaalde informatie met ouders te delen, ga ik daar altijd eerst over in gesprek met het kind. Samen kijken we hoe we dit op een veilige en respectvolle manier kunnen bespreken.",
      "Alleen wanneer er ernstige zorgen zijn over de veiligheid van het kind of van iemand anders, kan het nodig zijn om hiervan af te wijken. Ook dan ga ik daar open en zorgvuldig mee om.",
    ],
  },
  {
    q: "Is mijn vraag wel groot genoeg?",
    a: [
      "Je hoeft niet te wachten tot het echt moeilijk wordt. Soms zijn één of enkele gesprekken al voldoende om opnieuw overzicht, rust of vertrouwen te vinden.",
      "Je bent welkom met kleine en grote vragen. Samen kijken we wat jij of je gezin nodig heeft.",
    ],
  },
];

export const scrollToId = (href) => {
  const el = document.querySelector(href);
  if (el) {
    if (window.__lenis) {
      window.__lenis.scrollTo(el, { offset: -72 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
    return;
  }
  // element not on current page → navigate to home with hash, then scroll
  if (window.__navigate) {
    window.__navigate("/" + href);
  }
};
